import { create } from "zustand";
import { api } from "@/lib/api";

interface User {
  id: string;
  username: string;
}

interface AuthState {
  user: User | null;
  loading: boolean;
  login: (username: string, password: string) => Promise<void>;
  register: (username: string, password: string) => Promise<void>;
  logout: () => void;
  checkAuth: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,

  login: async (username, password) => {
    await api.login(username, password);
    const user = await api.getMe();
    set({ user });
  },

  register: async (username, password) => {
    await api.register(username, password);
    const user = await api.getMe();
    set({ user });
  },

  logout: () => {
    api.logout();
    set({ user: null });
  },

  checkAuth: async () => {
    if (!api.isAuthenticated()) {
      set({ loading: false });
      return;
    }
    try {
      const user = await api.getMe();
      set({ user, loading: false });
    } catch {
      api.logout();
      set({ user: null, loading: false });
    }
  },
}));
